import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BackButton } from '@twa-dev/sdk/react'
import cn from 'classnames'

import { FlexLayout } from 'layouts'
import { Button, CrownIcon, Paper, Radio } from 'components'
import { analyticsContext } from 'contexts'

import { PayVariant } from './components'
import './styles.scss'

enum payPeriods {
  YEAR = 'Year',
  MONTH = 'Month',
}

const prices = {
  [payPeriods.MONTH]: 349,
  [payPeriods.YEAR]: '1 999',
}

const payVariants = {
  short: <PayVariant label="Месячная подписка" cost="349₽" period="год" />,
  long: <PayVariant label="166 /мес - Годовая" cost="1 999₽" period="мес" className="year" />,
}

export const Premium = () => {
  const navigate = useNavigate()
  const [payType, setPayType] = useState(payPeriods.YEAR)

  const onYearPay = () => {
    analyticsContext.trackEvent('subscription_type_selected', { value: 'ANNUAL' })
    setPayType(payPeriods.YEAR)
  }

  const onMonthPay = () => {
    analyticsContext.trackEvent('subscription_type_selected', { value: 'MONTHLY' })
    setPayType(payPeriods.MONTH)
  }

  const onPremiumClick = () => {
    analyticsContext.trackEvent('graph_premium_clicked')
    navigate('/payment', {
      state: {
        type: payType,
      },
    })
  }

  return (
    <FlexLayout.Container
      className="premium-container with-mobile-indent with-menu-padding"
      vertical
    >
      <BackButton />
      <FlexLayout.Content className="scrollable-layout" scrollable>
        <div className="premium-content">
          <div className="premium-icon">
            <CrownIcon fill="var(--white)" />
          </div>
          <div className="premium-header">Премиум доступ</div>
          <div className="premium-subheader">Расширенная аналитика и графики</div>

          <Paper
            className={cn('pay-type', { selected: payType === payPeriods.MONTH })}
            onClick={onMonthPay}
          >
            <Radio
              className="pay-radio"
              onChange={() => {}}
              onClick={(e) => e.stopPropagation()}
              checked={payType === payPeriods.MONTH}
              label={payVariants.short}
            />
          </Paper>
          <Paper
            className={cn('pay-type year', { selected: payType === payPeriods.YEAR })}
            onClick={onYearPay}
          >
            <Radio
              className="pay-radio"
              onChange={() => {}}
              onClick={(e) => e.stopPropagation()}
              checked={payType === payPeriods.YEAR}
              label={payVariants.long}
            />
          </Paper>

          <div className="cancel-notice">
            <div className="cancel-notice-header">🌟 Бесплатная отмена в течение 7 дней</div>
            <div className="cancel-notice-text">
              Оформите подписку сейчас. Если передумаете - отмените в любой момент в течение 7 дней,
              и мы вернем деньги.
            </div>
          </div>

          <div className="include-notice">
            <div className="include-notice-header">Что входит:</div>
            <ul className="include-notice-list">
              <li>
                Расширенные графики с питанием, сном и поведением ребенка для глубокого анализа
                развития
              </li>
              <li>Поддержка 24/7</li>
            </ul>
          </div>

          <Button className="premium-btn" width="100%" onClick={onPremiumClick}>
            🌟 Купить 🌟
            <div>
              за <span>{prices[payType]}₽</span>
            </div>
          </Button>
        </div>
      </FlexLayout.Content>
    </FlexLayout.Container>
  )
}
